// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"884ea005","239":"f8472c79","455":"17c70d09"}[chunkId] + ".chunk.js";
};